/**
 * AARKA Product Hero — Immersive reveal + parallax + variant swap
 * Features:
 * - Letter-by-letter title reveal on load
 * - Parallax depth layers (image moves slower than text)
 * - Cross-fade image on variant change
 * - Works with GSAP/ScrollTrigger if available, graceful fallback
 */
if (!customElements.get('aarka-product-hero')) {
  customElements.define('aarka-product-hero', class extends HTMLElement {
    connectedCallback() {
      this.img = this.querySelector('.aph-product-img');
      this.titleEl = this.querySelector('.aph-title');
      this.imageWrap = this.querySelector('.aph-image');
      this.infoWrap = this.querySelector('.aph-info');

      // Wrap title letters for animation
      this.wrapLetters();

      // Start entrance animation
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.classList.add('aph--loaded');
          this.revealTitle();
        });
      });

      // Setup parallax with GSAP if available
      this.setupParallax();

      // Hero uses custom-picked images, not variant images — no swap needed
    }

    disconnectedCallback() {
      if (this._scrollTrigger) this._scrollTrigger.kill();
    }

    wrapLetters() {
      if (!this.titleEl || this.titleEl.querySelector('.aph-letter')) return;
      var text = this.titleEl.textContent.trim();
      this.titleEl.textContent = '';

      for (var i = 0; i < text.length; i++) {
        var span = document.createElement('span');
        if (text[i] === ' ') {
          span.className = 'aph-letter aph-letter--space';
          span.innerHTML = '&nbsp;';
        } else {
          span.className = 'aph-letter';
          span.textContent = text[i];
        }
        span.style.transitionDelay = (i * 30) + 'ms';
        this.titleEl.appendChild(span);
      }
    }

    revealTitle() {
      if (!this.titleEl) return;
      // Small delay for the class to trigger transitions
      setTimeout(() => {
        this.titleEl.classList.add('aph-title--revealed');
      }, 200);
    }

    setupParallax() {
      var self = this;

      function setup() {
          var gsap = window.AARKA.gsap;
          var ScrollTrigger = window.AARKA.ScrollTrigger;

          // Image moves slower = feels further away (depth)
          if (self.imageWrap) {
            gsap.to(self.imageWrap, {
              y: 80,
              ease: 'none',
              scrollTrigger: {
                trigger: self,
                start: 'top top',
                end: 'bottom top',
                scrub: 0.5
              }
            });
          }

          // Info moves faster = feels closer
          if (self.infoWrap) {
            gsap.to(self.infoWrap, {
              y: -40,
              opacity: 0,
              ease: 'none',
              scrollTrigger: {
                trigger: self,
                start: 'top top',
                end: '60% top',
                scrub: 0.5
              }
            });
          }

          // Glow fades out
          var glow = self.querySelector('.aph-glow');
          if (glow) {
            gsap.to(glow, {
              opacity: 0,
              ease: 'none',
              scrollTrigger: {
                trigger: self,
                start: 'top top',
                end: '80% top',
                scrub: 0.5
              }
            });
          }

          // Scroll hint fades out quickly
          var scrollHint = self.querySelector('.aph-scroll-hint');
          if (scrollHint) {
            gsap.to(scrollHint, {
              opacity: 0,
              ease: 'none',
              scrollTrigger: {
                trigger: self,
                start: 'top top',
                end: '20% top',
                scrub: 0.3
              }
            });
          }
      }

      if (window.AARKA && window.AARKA.ready) {
        setup();
      } else {
        document.addEventListener('aarka:scroll-ready', setup, { once: true });
      }
    }

  });
}
